$(document).ready(function(){
    $('#sliderUpGalery').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        dots: false,
        arrows: false,
        asNavFor: '#sliderDownGalery',
        lazyLoad: 'ondemand'
    });
    $('#sliderDownGalery').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: false,
        dots: false,
        arrows: true,
        prevArrow: $('.sliderDownGalery .prevArrow'),
        nextArrow: $('.sliderDownGalery .nextArrow'),
        asNavFor: '#sliderUpGalery',
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
        ]
    });
});

$('#sliderUpGalery video').click(function () {
    var video = document.getElementById(this.id);
    if (video.paused) {
        $("#"+this.id).attr('controls');
        video.play();
    } else {
        video.pause();
    }
});
